<nav id="sidebarMenu" class="d-md-block bg-light sidebar collapse">
    <div class="full-height-menu">
        <div class="assesment-info" *ngIf="assessmentDetails" [ngClass]="isArabic ? 'arabicAlign' : ''">
            <div class="assessmentIcon">
                <div class="imgSpan"><img src="../../../../assets/images/book.png" alt=""></div>
            </div>
            <div class="assessmentDetails">
                <div class="assessmentLabel" [ngClass]="isArabic ? 'arabicAlign' : ''">
                    <span class="leftLabel" [ngClass]="isArabic ? 'arabicLabelAlign' : ''">
                        <span *ngIf="!isArabic">Assessment : </span>
                        <span *ngIf="isArabic">: التقييم</span>
                    </span>
                    <span [ngClass]="isArabic ? 'rightAlign' : ''">{{assessmentDetails.questionnaireName}}</span>
                </div>
                <div *ngIf="assessmentDetails.targetDate" class="assessmentLabel"
                    [ngClass]="isArabic ? 'arabicAlign' : ''">
                    <span class="leftLabel" [ngClass]="isArabic ? 'arabicLabelAlign' : ''">
                        <span *ngIf="!isArabic">Target Date : </span>
                        <span *ngIf="isArabic">: التاريخ المستهدف</span>
                    </span>
                    <span [ngClass]="isArabic ? 'rightAlign' : ''">{{targetDate}}</span>
                </div>
                <div class="assessmentLabel" [ngClass]="isArabic ? 'arabicAlign' : ''">
                    <span class="leftLabel" [ngClass]="isArabic ? 'arabicLabelAlign' : ''">
                        <span *ngIf="!isArabic">Assessment Entity : </span>
                        <span *ngIf="isArabic">: أسم الشركة</span>
                    </span>
                    <span [ngClass]="isArabic ? 'rightAlign' : ''">{{assessmentDetails.assessmentUnit}}</span>
                </div>
                <div *ngIf="!isView && ((assessmentDetails.questionnaireProgress || assessmentDetails.questionnaireProgress == 0 || isChecker) && !isResubmit)"
                    class="progressPercent" [ngClass]="isArabic ? 'rightAlignArabic' : ''">
                    <span *ngIf="!isArabic">Status of Completion</span>
                    <span *ngIf="isArabic">حالة التقييم</span> :
                    <!-- <span>{{qnsComplete}}</span> -->
                    <span>{{qnsComplete2}}</span>
                    <!-- <span *ngIf="!isChecker">({{assessmentDetails.questionnaireProgress | number:'1.2-2'}})</span> -->
                    <span *ngIf="!isChecker">({{assessmentProgressPercentage | number:'1.2-2'}}%)</span>
                </div>
                <div class="showProgress" (click)="goToProgressTracker();"
                    [ngClass]="isArabic ? 'rightAlignArabic' : ''"
                    *ngIf="(assessmentDetails.questionnaireProgress || assessmentDetails.questionnaireProgress == 0) && !isResubmit">
                    <span *ngIf="!isArabic">Show Progress Tracker </span>
                    <span *ngIf="isArabic">عرض مؤشر التقدم للتقييم</span>
                </div>
            </div>
        </div>
        <div class="categoryList">
            <ul class="nav flex-column">
                <li class="nav-item" (click)="loadCategory(cList)" *ngFor="let cList of categoryList; let idx = index;"
                    [ngClass]="isArabic ? 'rightAlign' : ''">
                    <a class="nav-link" aria-current="page" href="javascript:void(0);"
                        [ngClass]="selectedCategory === cList ? 'active' : ''">
                        <span data-feather="home" class="align-text-bottom">
                            <span *ngIf="!isArabic">{{cList}}</span>
                            <span *ngIf="isArabic">{{categoryArabicList[idx]}}</span>
                        </span>

                    </a>
                </li>
            </ul>
        </div>
    </div>
</nav>